export default __webpack_public_path__ + "static/media/usc_online_text.1cc43c55.svg";